import React, { useEffect } from "react";
import GeneralSectionComponent from "../generalSectionComponent";
import { ADMINISTRATIVE_DISTRICTS } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";

import { useDispatch } from "react-redux";
import {
  getAdministrativeDistricts,
  getAdministrativeDistrictsAll,
} from "../../../../redux/directoryMaintenance/administrativeDistrictsReducer/actionAdministrativeDistricts";
import AdministrativeDistrictsModal from "./administrativeDistrictsModal/administrativeDistrictsModal";

function AdministrativeDistricts() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAdministrativeDistrictsAll());
  }, [getAdministrativeDistrictsAll]);

  return (
    <GeneralSectionComponent
      title="Административные районы, обслуживаемые участком"
      dataFromStateSelector={(state) =>
        state.administrativeDistrictsReducer.administrativeDistrictsAll
      }
      getAction={getAdministrativeDistricts}
      headerColumns={ADMINISTRATIVE_DISTRICTS}
      ModalComponent={AdministrativeDistrictsModal}
      searchTableSize={15}
    />
  );
}

export default AdministrativeDistricts;
